export default __webpack_public_path__ + "static/media/stacked_sheets_small.29e70440.png";